import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { isPartOf } from '@big-direkt/utils/shared';
import { catchError, map, of, type Observable } from 'rxjs';
import { SECTION_IDS, type SectionLockId, type SectionLockIdentifier } from '../models/section-lock-identifier.model';
import { type SectionLockDto } from '../models/section-lock.dto';
import { EnvironmentService } from './environment.service';

@Injectable({
    providedIn: 'root',
})
export class SectionLocksService {
    private readonly environment = inject(EnvironmentService);
    private readonly http = inject(HttpClient);

    public getBySectionIds(sectionIds: SectionLockId[]): Observable<SectionLockIdentifier[]> {
        return this.http
            .get<SectionLockDto>(`${this.environment.baseHref}/api/sections_lock/list/frontend/${this.environment.version}`, {
                params: { cb: Date.now() },
            })
            .pipe(
                map(response =>
                    response.data
                        .filter(item => item.active)
                        .map(item => {
                            if (!isPartOf<SectionLockId>(item.sectionId, SECTION_IDS)) {
                                // eslint-disable-next-line no-console,  @typescript-eslint/restrict-template-expressions
                                console.error(`unknown sectionId: ${item.sectionId}. Add the sectionId to the known ids or check cms for valid ids`);
                            }

                            return {
                                sectionId: item.sectionId,
                                formNodeIds: item.formNodeIds,
                                errorNode: item.errorNode,
                            };
                        }),
                ),
                map(sectionLocks => sectionLocks.filter(sectionLock => sectionIds.includes(sectionLock.sectionId))),
                catchError(() => of([])),
            );
    }

    public isEnabled(sectionId: SectionLockId): Observable<boolean> {
        return this.getBySectionIds([sectionId]).pipe(map(sectionLocks => sectionLocks.length > 0));
    }
}
